import React from 'react';

import noop from 'lodash/noop';

import { cn } from '@src/components/ui';


const Form = React.forwardRef((props, ref) => {
  const { children, className, onSubmit = noop, ...restProps } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onSubmit(e);
  };

  return (
    <form
      ref={ref}
      className={cn('flex flex-col gap-4', className)}
      onSubmit={handleSubmit}
      {...restProps}
    >
      {children}
    </form>
  );
});

Form.displayName = 'Form';
export default Form;
